module.exports = __webpack_public_path__ + "static/media/divider.04cb9030.svg";